var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceRadiophoniqueprincipal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.25 86.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-2,.cls-3{stroke:#5a0838;stroke-miterlimit:10;stroke-width:1.5px;}.cls-3{fill:#f7c9c6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Service Radiophonique principal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.88,85.8a.5.5,0,0,1-.5-.5V81.8c0-2,1-5.84,7.62-8.46A30.4,30.4,0,0,1,21.53,72,31,31,0,0,1,.5,42.67v-3a.5.5,0,0,1,.5-.5H6.3V25.64a25.14,25.14,0,0,1,50.28,0V39.17h5.3a.5.5,0,0,1,.5.5v3a30.91,30.91,0,0,1-3.66,14.56L72.64,75a.5.5,0,0,1-.39.81l-.16,0L49.23,68a30.69,30.69,0,0,1-7.39,3.85,31.36,31.36,0,0,1,5.35,1.54c6.63,2.62,7.62,6.43,7.62,8.46v3.5a.5.5,0,0,1-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.44,1A24.67,24.67,0,0,1,56.08,25.64v14h5.8v3a30.27,30.27,0,0,1-3.75,14.61L66,67.37l6.24,8-9.58-3.3L49.15,67.4a30.14,30.14,0,0,1-9.38,4.55A33.8,33.8,0,0,1,47,73.81c6.36,2.51,7.31,6.09,7.31,8v3.5H9.88V81.8c0-1.91.95-5.48,7.31-8a32.73,32.73,0,0,1,6.41-1.73A30.49,30.49,0,0,1,1,42.67v-3H6.8v-14A24.67,24.67,0,0,1,31.44,1m0-1A25.67,25.67,0,0,0,5.8,25.64v13H1a1,1,0,0,0-1,1v3A31.49,31.49,0,0,0,19.83,71.89a28.86,28.86,0,0,0-3,1c-6.91,2.73-7.94,6.76-7.94,8.93v3.5a1,1,0,0,0,1,1H54.32a1,1,0,0,0,1-1V81.8c0-2.16-1-6.2-7.94-8.93a30,30,0,0,0-3.82-1.2,31.24,31.24,0,0,0,5.75-3.16l13,4.48,9.58,3.3A1,1,0,0,0,73,74.73l-6.24-8-7.48-9.57a31.42,31.42,0,0,0,3.56-14.51v-3a1,1,0,0,0-1-1h-4.8v-13A25.67,25.67,0,0,0,31.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.75,42.67A26.94,26.94,0,0,1,31.81,69.6h0A26.94,26.94,0,0,1,4.87,42.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.58,68.19,50.46,52.69l.1-.09-.09-.34a20.94,20.94,0,0,0,2.48-9.89V25.64A21.2,21.2,0,0,0,31.81,4.5h0A21.2,21.2,0,0,0,10.67,25.64V42.37A21.2,21.2,0,0,0,31.81,63.52h0A20.84,20.84,0,0,0,41.71,61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.75,81.8c0-3.82,8.38-6.92,18.72-6.92S51.2,78,51.2,81.8Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.47,
    y1: 69.6,
    x2: 32.47,
    y2: 74.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.67,
    y1: 22.31,
    x2: 21.36,
    y2: 22.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.67,
    y1: 34.49,
    x2: 21.36,
    y2: 34.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.67,
    y1: 46,
    x2: 21.36,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.25,
    y1: 22.31,
    x2: 52.95,
    y2: 22.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.25,
    y1: 34.49,
    x2: 52.95,
    y2: 34.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.25,
    y1: 46,
    x2: 52.95,
    y2: 46
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRadiophoniqueprincipal);
export default __webpack_public_path__ + "static/media/Service Radiophonique principal.a8dbc7ee7c0d5f90b8181957806d69b3.svg";
export { ForwardRef as ReactComponent };